module.exports = __webpack_public_path__ + "img/tableros.34383287.png";